import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ArrowRight } from "lucide-react";

import { APP_STORE_URL, IS_LIVE } from "../../MobileApp/appStoreUrl";
import appStoreBadge from "../../../assets/images/appStoreBadge.svg";
import swipeImg from "../../../assets/images/mobileWaitlist/swipe.webp";
import myJobsImg from "../../../assets/images/mobileWaitlist/my-jobs.webp";
import mailboxImg from "../../../assets/images/mobileWaitlist/mailbox.webp";

gsap.registerPlugin(ScrollTrigger);

const CinematicMobileApp = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        ".cinematic-mobileapp__phone",
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.12,
          ease: "power3.out",
          scrollTrigger: {
            trigger: ".cinematic-mobileapp__stage",
            start: "top 80%",
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="cinematic-mobileapp" ref={sectionRef} id="mobile-app">
      <div className="cinematic-mobileapp__inner">
        <div className="cinematic-mobileapp__text">
          <p className="cinematic-mobileapp__label">Mobile App</p>
          <h2 className="cinematic-mobileapp__title">
            Your job search,{" "}
            <span className="cinematic-mobileapp__title-drama">
              in your pocket.
            </span>
          </h2>
          <p className="cinematic-mobileapp__subtitle">
            Swipe to apply, track every application, and read recruiter replies
            on the go — the full JobHarvest experience, now on iPhone.
          </p>
          <div className="cinematic-mobileapp__actions">
            {IS_LIVE && (
              <a
                className="cinematic-mobileapp__store-badge"
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Download JobHarvest on the App Store"
              >
                {/* Apple's official marketing badge artwork */}
                <img src={appStoreBadge} alt="Download on the App Store" />
              </a>
            )}
            <a href="/mobile-app" className="cinematic-mobileapp__learn">
              <span>Learn More</span>
              <ArrowRight size={17} />
            </a>
          </div>
        </div>

        <div className="cinematic-mobileapp__stage">
          <img
            className="cinematic-mobileapp__phone cinematic-mobileapp__phone--side cinematic-mobileapp__phone--left"
            src={myJobsImg}
            alt="JobHarvest application tracking screen"
            loading="lazy"
          />
          <img
            className="cinematic-mobileapp__phone cinematic-mobileapp__phone--main"
            src={swipeImg}
            alt="JobHarvest swipe to apply screen"
            loading="lazy"
          />
          <img
            className="cinematic-mobileapp__phone cinematic-mobileapp__phone--side cinematic-mobileapp__phone--right"
            src={mailboxImg}
            alt="JobHarvest unified mailbox screen"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default CinematicMobileApp;
